import React from 'react';
import { OnwardLink } from '@/styles/blocks';
import { buildNetsuiteInvoiceUrl } from '@/utilities/netsuite';

// Renders an invoice's NetSuite id as a link to the NetSuite transaction record, with graceful
// fallbacks: '--' when the invoice hasn't been pushed, or the bare id when we can't build a URL
// (missing account id or an unmapped invoice type). Used by the accounting invoice tables and the
// single-invoice detail card. stopPropagation keeps clicks off any surrounding clickable row.
export const NetsuiteLink = ({ invoice }) => {
    if (!invoice?.netsuite_invoice_id) return '--';

    const url = buildNetsuiteInvoiceUrl(invoice);
    if (!url) return invoice.netsuite_invoice_id;

    return (
        <OnwardLink href={url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
            {invoice.netsuite_invoice_id}
        </OnwardLink>
    );
};
